// HomePage.tsx
import * as React from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material'; 
import NewsExpanded from './Components/News/NewsExpanded';
import ApplicationSelect from './Components/ApplicationSelect/ApplicationSelect';
import ReviewComponent from './Components/Review/ReviewComponent';
import CustomMenu from '../../components/CustomMenu/CustomMenu';
import ProgressList from './Components/Progress/ProgressList';
import NotificationTicker from './Components/NotificationTicker';



/**
 * ホームページコンポーネント
 * - 進捗照会・申請選択・審査管理の各コンポーネントを配置する
 * - レスポンシブ対応（スマートフォン：縦並び、PC：横並び）
 */
export default function HomePage() {

  // useMediaQueryでスクリーンサイズをチェック
  const isMobile = useMediaQuery('(max-width:600px)');  // 600px以下の場合はスマートフォンデバイス

  return (
   <CustomMenu>
     <Box sx={{display:'flex',flexDirection:'column'}}>
        {/* NotificationTicker コンポーネント */}
          {/* <Box sx={{mx:1,
          }}>
          < NotificationTicker/>
          </Box> */}
        {/* ニュース登録・編集機能は未実装のためコメントアウト */}
         {/* NewsExpandedコンポーネント */}
        <Box sx={{
          display:'flex',
          flexGrow:1,
          mb:2
          }}>
          <Box sx={{ width: '100%' }}>
          <NewsExpanded />  
          </Box>
        </Box>

        {/* スクリーンサイズによってflexの配列方式を調整 */}
        <Box sx={{
          width:'100%',
          display:'flex',
          flexDirection: isMobile ? 'column' : 'row', 
          justifyContent:'flex-start',
          gap:3,
          mt:2,
        }}>           
        
        {/* ProgressListコンポーネント */}
        <Box sx={{
          flexGrow: 1,
          flexBasis: isMobile ? '100%' : '30%',
          ml:isMobile ? 2 : 0.5,
          mr:isMobile ? 2 : 0,
          mb:2,
          minWidth:0
          // transform: 'scale(0.8)',
          // position:'relative',
          // top:-60
        }}>
         <ProgressList />

        </Box>

        {/* Reviewコンポーネント */}
        <Box sx={{
          flexGrow: 1,
          flexBasis: isMobile ? '100%' : '30%',
          ml:isMobile ? 2 : 0,
          mr:isMobile ? 2 : 0.5,
          mb:isMobile ? 2 : 0,
          minWidth:0
          // transform: 'scale(0.8)',
          // position:'relative',
          // top:-60
        }}>
        <ReviewComponent/>        
        </Box>
      </Box>

      <Box sx={{
          width:'100%',
          display:'flex',
          flexDirection: isMobile ? 'column' : 'row', 
          justifyContent:'flex-start',
          gap:3
        }}>
      {/* ApplicationSelect コンポーネント */}
      <Box sx={{
            ml:isMobile ? 2 : 0.5,
            flexGrow:1,
            flexBasis: isMobile ? '100%' : '30%',  
            mr:isMobile ? 2 : 0,
            mb:2,
            minWidth:0
          }}>
          <ApplicationSelect />
      </Box>

      {/* ApplicationSelect コンポーネントの配置を整えるためのダミーのパーツ */}
      {!isMobile && (
      <Box sx={{
          flexGrow: 1,
          flexBasis: isMobile ? '100%' : '30%',
          ml:isMobile ? 2 : 0,
          mr:isMobile ? 2 : 0.5,
          mb:isMobile ? 2 : 0,
          minWidth:0
        }}></Box>)}
      </Box>
      
</Box>
        {/* 左下のSVG図 */}
        {!isMobile && (
          <Box
            component="img"
            src="/device.svg"  
            alt="Background icon"
            sx={{
              position: 'absolute',
              right: '100px', 
              bottom: '0px',
              width: '270px',
              height: '270px',
              opacity: 0.5,
              zIndex: -1,
            }}
          />
        )}
    
   
    </CustomMenu>
      
      
  );
  }

   
 
